import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  ImageSuiteApps,
  ModelImageFluxName,
  ModelImageStabilityName,
  TextSuiteApps,
  TextSuitesApps,
  WorkflowAppType,
} from "../../../Helper";
import { useAppSelector } from "../../../store/hooks";
import { Box } from "@mui/material";
import BlueCheckBoxIcon from "../../../Custom-imeges/BlueCheckBoxIcon";
import { TranslatorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TranslatorIcon";
import { HumanizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/HumanizeIcon";
import { SummarizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/SummarizeIcon";
import { ParaphraseIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ParaphraseIcon";
import { PromptEngineerIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/PromptEngineerIcon";
import { SuitesAppTypes } from "../../../store/one-query/workflowsSlice";
import {
  AppsVisibilityType,
  WorkflowAppsType,
  workflowItem,
} from "../../../Types/Workflow-Types";
import TranslatorSetting from "./TextApps/TranslatorSetting";
import HumanizerSetting from "./TextApps/HumanizerSetting";
import SummarizerSetting from "./TextApps/SummarizerSetting";
import ParaphraserSetting from "./TextApps/ParaphraserSetting";
import PromptGeneratorSetting from "./TextApps/PromptGeneratorSetting";
import TextToImageSetting from "./ImageApps/TextToImageSetting";
import LogoGeneratorSetting from "./ImageApps/LogoGeneratorSetting";
import IconGeneratorSetting from "./ImageApps/IconGeneratorSetting";
import IllustrationGeneratorSetting from "./ImageApps/IllustrationGeneratorSetting";
import ImageRestoreSetting from "./ImageApps/ImageRestoreSetting";
import TextExtractionSetting from "./ImageApps/TextExtractionSetting";
import BackgroundRemoverSetting from "./ImageApps/BackgroundRemoverSetting";
import TextToVideoSetting from "./VideoApps/TextToVideoSetting";
import ImageToVideoSetting from "./VideoApps/ImageToVideoSetting";
import { SettingItemObjType, videoModelType } from "../../../Types/VideoSuite-Types";
import { useGetVideoSuiteAppSettings } from "../../../store/Apis/SuitesApps/VideoSuiteApi";
import { GenerateImgIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateImgIcon";
import { GenerateLogoIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateLogoIcon";
import { GenerateIconIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIconIcon";
import { GenerateIllsturationsIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIllsturationsIcon";
import { ImageRestoreIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageRestoreIcon";
import { ImageTranscaptionIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageTranscaptionIcon";
import { BgRemoverIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/BgRemoverIcon";
import TextToVideoIcon from "../../../Custom-imeges/VideoSuite/TextToVideoIcon";
import ImageToVideoIcon from "../../../Custom-imeges/VideoSuite/ImageToVideoIcon";

interface Props {
  show: boolean;
  handleClose: () => void;
  currentStep: workflowItem;
  tempStep: workflowItem;
  AddNewStep: (data: workflowItem) => void;
  isReplacing: boolean;
  workflowDetails: workflowItem[];
  setTempStep: (data: workflowItem) => void;
  handleChooseAppDetails: () => void;
  currentSelectedWorkflowData: workflowItem[];
  appsVisibility:AppsVisibilityType;
  handleModelSettingChanges?:(appId:string,name:string,value: number | string | SettingItemObjType | videoModelType)=>void;
  outputTypeOfLastApp:string;
  handleUserInputImageChange:(activeAppId:string,input:File |string | null)=>void;
  handleUserInputTextChange:(activeAppId:string,input:string | null)=>void;
  handleUpdateAppsVisibity:(appName:string)=>void;
  isFirstStep:boolean
}

const PopupForDisplayApp = ({
  show,
  handleClose,
  currentStep,
  tempStep,
  AddNewStep,
  isReplacing,
  setTempStep,
  workflowDetails,
  handleChooseAppDetails,
  handleUserInputImageChange,
  handleUserInputTextChange,
  handleModelSettingChanges,
  appsVisibility,
  handleUpdateAppsVisibity,
  isFirstStep,
  currentSelectedWorkflowData,
  outputTypeOfLastApp,
}: Props) => {
  const [selectedFromDropdownItem, setSelectedFromDropdownItem] = useState("");
  const [sliderValue, setSliderValue] = useState<number>(1);
  const allTextSuitesApps = useAppSelector((s) => s.workflows.textSuitesApps);
  const [selectedToDropdownItem, setSelectedToDropdownItem] = useState("");
  const WorkflowImageAppSetting = useAppSelector(
    (s) => s.workflows.WorkflowImageAppSetting
  );
  const videoSuiteAppSettings=useAppSelector((s)=>s.workflows.videoAppSetting)
  const activeItemData = useMemo(() => {
    if (currentStep.suiteType === WorkflowAppType.TextSuite) {
      let appName = isReplacing ? tempStep?.appType : currentStep.appType;
      const appDetails = TextSuitesApps.find((app) => app.appTitle === appName);
      if (setSelectedFromDropdownItem)
        setSelectedFromDropdownItem(appDetails?.defaultSelectorOption || "");
      return appDetails;
    } else if (currentStep.suiteType === WorkflowAppType.ImageSuite) {
      return WorkflowImageAppSetting;
    }
  }, [currentStep, show]);

    useEffect(() => {
    const modelData = videoSuiteAppSettings?.[0] 
    const randomValue=Math.floor(Math.random() * 1000000 + 1)
    if (!modelData) return;
    const newSettings = {
      selectedModel: { name: modelData.name, version: modelData.version },
      selectedSize: modelData.modelDimensions?.[0]?.description || "",
      selectedStyle: modelData.modelStyles?.[0] || "",
      selectedDuration: modelData.modelDurations?.[0]?.value.toString() || "",
      selectedMode: modelData.modelVideoQualities?.[0]?.description || "",
      generateTime: modelData.generationTime,
      seed: randomValue,
      creditsNeeded: 0,
    };
  setTempStep({
    ...tempStep,
    videoSettings: newSettings,
  });
   
  }, [videoSuiteAppSettings]);
  useEffect(() => {
    if (!isReplacing ) {
      if (currentStep?.selectedFromDropdownItem)
        setSelectedFromDropdownItem(currentStep?.selectedFromDropdownItem);
      if (currentStep?.selectedToDropdownItem)
        setSelectedToDropdownItem(currentStep?.selectedToDropdownItem);
      if (currentStep?.sliderValue) setSliderValue(currentStep?.sliderValue);
    }
  }, [show, currentStep]);

  const TextSuitesAppsIcons: Partial<Record<WorkflowAppsType, JSX.Element>> = {
    [WorkflowAppsType.Translator]: (
      <TranslatorIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.Humanizer]: (
      <HumanizeIcon className="text-nav-item-icon-without-opacity-stroke" />
    ),
    [WorkflowAppsType.Summarizer]: (
      <SummarizeIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.Paraphraser]: (
      <ParaphraseIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.PromptGenerator]: (
      <PromptEngineerIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.TextToImage]: (
      <GenerateImgIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.LogoGenerator]: (
      <GenerateLogoIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.IconGenerator]: (
      <GenerateIconIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.IllustrationGenerator]: (
      <GenerateIllsturationsIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.ImageRestore]: (
      <ImageRestoreIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.TextExtraction]: (
      <ImageTranscaptionIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.BackgroundRemover]: (
      <BgRemoverIcon className="text-nav-item-icon-without-opacity-stroke" />
    ),
    [WorkflowAppsType.TextToVideo]: (
      <TextToVideoIcon className="text-nav-item-icon-without-opacity" />
    ),
    [WorkflowAppsType.ImageToVideo]: (
      <ImageToVideoIcon className="text-nav-item-icon-without-opacity" />
    ),
  };

  const handleSetActiveItem = (app: SuitesAppTypes): void => {
    handleUpdateAppsVisibity(app.appType);
    setTempStep({
      appId:app.id,
      appType: app.appType,
      suiteType: app.suiteType,
      selectedFromDropdownItem: "",
      selectedToDropdownItem: "",
      appOrder: currentStep.appOrder,
      sliderValue: 1,
      inputType: app.inputType,
      outputType: app.outputType,
    });
    handleChooseAppDetails();
  };

  const addNewStep = () => {
    if (currentStep.selectedFromDropdownItem)
      setSelectedFromDropdownItem(selectedFromDropdownItem);
    if (currentStep.selectedToDropdownItem)
      setSelectedToDropdownItem(selectedFromDropdownItem);
    AddNewStep({
      ...currentStep,
      selectedFromDropdownItem,
      selectedToDropdownItem,
      ...(currentStep.appType === TextSuiteApps.Summarizer
        ? { sliderValue }
        : {}),
    });
    handleClose();
  };

  const cancelNewStep = () => {
    setTempStep({
      appId:"",
      appType: "",
      selectedFromDropdownItem: "",
      selectedToDropdownItem: "",
      appOrder: 0,
      sliderValue: 1,
      suiteType:0,
      videoSettings:{
        selectedSize: "",
        selectedModel: {
          name: "",
          version: ""
        },
        selectedMode: "",
        selectedDuration: "",
        selectedStyle: {description:""},
        seed: null,
        generateTime: "",
        creditsNeeded:0
      }
    });
    handleClose();
  };

  const handleReplace = () => {
    if (tempStep.appType) {
      if (tempStep.selectedFromDropdownItem)
        setSelectedFromDropdownItem(selectedFromDropdownItem);
      if (tempStep.selectedToDropdownItem)
        setSelectedToDropdownItem(selectedFromDropdownItem);
      if (tempStep.sliderValue) setSliderValue(sliderValue);
      AddNewStep({
        ...tempStep,
        selectedFromDropdownItem,
        selectedToDropdownItem,
        ...(tempStep.appType === TextSuiteApps.Summarizer
          ? { sliderValue }
          : {}),
      });
    }
    handleClose();
  };

  const isValidAppStep = (app: SuitesAppTypes) => {
    const prevStep =
      currentSelectedWorkflowData.length > 0
        ? currentSelectedWorkflowData.find(
            (step) => step.appOrder === currentStep.appOrder - 1
          )
        : null;

    const nextStep =
      currentSelectedWorkflowData.length > 0
        ? currentSelectedWorkflowData.find(
            (step) => step.appOrder === currentStep.appOrder + 1
          )
        : null;

    // Check if the previous step is valid for the current app
    const validFromPrevious =
      !prevStep || app.inputType.includes(prevStep?.outputType ||"");

    // Check if the next step is valid for the current app
    const validToNext = !nextStep || nextStep.inputType?.includes(app.outputType||"");

    return validFromPrevious && validToNext;
  };
  const isSaveStepDisabled=currentStep?.appType==="Image to Video"&&workflowDetails.length>0&&workflowDetails[0]?.appType!=="Image to Video"&&(!currentStep?.userInput&&!currentStep?.userInputText)
  return (
    <Modal
      className={`personaModal addStepModal ${
        isReplacing ? "Replace-apps" : ""
      }`}
      show={show}
      style={{ overflow: "hidden" }}
      size="lg"
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton onHide={cancelNewStep}>
        <Modal.Title>
          {isReplacing ? (
            <p className="mb-0">Replace {currentStep.appType}</p>
          ) : (
            <p className="mb-0">{currentStep.appType}</p>
          )}
        </Modal.Title>
      </Modal.Header>
      {isReplacing ? (
        <Modal.Body>
          <Box className={`display-apps workflows-apps mb-2`}>
            {allTextSuitesApps
              .filter(
                (app) =>
                  app.appType !== TextSuiteApps.TitleGenerator &&
                  app.appType !== TextSuiteApps.AiDetector &&
                  app.appType !== currentStep.appType &&
                  app.suiteType === currentStep.suiteType
              )
              .map((app, i) => (
                <Box
                  className={`${
                    isValidAppStep(app)
                      ? "active-workflow-app"
                      : "inactive-workflow-app"
                  }`}
                  key={i}
                  sx={{ display: "flex", alignItems: "center" }}
                  onClick={() => handleSetActiveItem(app)}
                >
                  <Box
                    className={`text-nav-item workflow-nav-item ${app.appType.toLowerCase()} app-workflow-item ${
                      tempStep.appType === app.appType && "active"
                    }`}
                    style={{ textDecoration: "none !important" }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {TextSuitesAppsIcons[app.appType as WorkflowAppsType]}
                    </Box>
                    <span
                      className={`text-nav-item-name  ${
                        tempStep.appType === app.appType && "active"
                      }`}
                      style={{ textDecoration: "none !important" }}
                    >
                      {app.appType}
                      {tempStep.appType === app.appType && (
                        <span className="ms-2">
                          <BlueCheckBoxIcon />
                        </span>
                      )}
                    </span>
                  </Box>
                </Box>
              ))}
          </Box>
          <div className="w-100 d-flex mt-3 align-items-center justify-content-end">
            <button
              className="CancelDeletePersonaBtn cancelCreation me-3"
              onClick={cancelNewStep}
            >
              Cancel
            </button>
            <button className={`createPersonaBtn`} onClick={handleReplace}>
              Replace
            </button>
          </div>
        </Modal.Body>
      ) : (
        <Modal.Body>
          <div
            className="w-100 "
            style={{ display: "flex", alignItems: "center" }}
          >
            {appsVisibility.Translator && (
              <TranslatorSetting
                activeItemData={activeItemData}
                isFirstStep={isFirstStep}
                selectedToDropdownItem={selectedToDropdownItem}
                selectedFromDropdownItem={selectedFromDropdownItem}
                setSelectedFromDropdownItem={setSelectedFromDropdownItem}
                setSelectedToDropdownItem={setSelectedToDropdownItem}
                canShow={appsVisibility.Translator}
                readOnly={false}
              />
            )}
            {appsVisibility.Humanizer && (
              <HumanizerSetting
                activeItemData={activeItemData}
                isFirstStep={isFirstStep}
                selectedFromDropdownItem={selectedFromDropdownItem}
                setSelectedFromDropdownItem={setSelectedFromDropdownItem}
                canShow={appsVisibility.Humanizer}
                readOnly={false}
              />
            )}
            {appsVisibility.Summarizer && (
              <SummarizerSetting
                sliderValue={sliderValue}
                activeItemData={activeItemData}
                isFirstStep={isFirstStep}
                selectedFromDropdownItem={selectedFromDropdownItem}
                setSelectedFromDropdownItem={setSelectedFromDropdownItem}
                setSliderValue={setSliderValue}
                canShow={appsVisibility.Summarizer}
                readOnly={false}
              />
            )}
            {appsVisibility.Paraphraser && (
              <ParaphraserSetting
                activeItemData={activeItemData}
                isFirstStep={isFirstStep}
                selectedFromDropdownItem={selectedFromDropdownItem}
                setSelectedFromDropdownItem={setSelectedFromDropdownItem}
                canShow={appsVisibility.Paraphraser}
                readOnly={false}
              />
            )}
            {appsVisibility["Prompt Generator"] && (
              <PromptGeneratorSetting
                isFirstStep={isFirstStep}
                canShow={appsVisibility["Prompt Generator"]}
                readOnly={false}
              />
            )}
            {appsVisibility["Text to Image"] && (
              <TextToImageSetting
                activeItemData={activeItemData}
                isFirstStep={isFirstStep}
                selectedToDropdownItem={selectedToDropdownItem}
                selectedFromDropdownItem={selectedFromDropdownItem}
                setSelectedFromDropdownItem={setSelectedFromDropdownItem}
                setSelectedToDropdownItem={setSelectedToDropdownItem}
                canShow={appsVisibility["Text to Image"]}
                readOnly={false}
              />
            )}
            {appsVisibility["Logo Generator"] && (
              <LogoGeneratorSetting
                activeItemData={activeItemData}
                isFirstStep={isFirstStep}
                selectedToDropdownItem={selectedToDropdownItem}
                selectedFromDropdownItem={selectedFromDropdownItem}
                setSelectedFromDropdownItem={setSelectedFromDropdownItem}
                setSelectedToDropdownItem={setSelectedToDropdownItem}
                canShow={appsVisibility["Logo Generator"]}
                readOnly={false}
              />
            )}
            {appsVisibility["Icon Generator"] && (
              <IconGeneratorSetting
                activeItemData={activeItemData}
                isFirstStep={isFirstStep}
                selectedToDropdownItem={selectedToDropdownItem}
                selectedFromDropdownItem={selectedFromDropdownItem}
                setSelectedFromDropdownItem={setSelectedFromDropdownItem}
                setSelectedToDropdownItem={setSelectedToDropdownItem}
                canShow={appsVisibility["Icon Generator"]}
                readOnly={false}
              />
            )}
            {appsVisibility["Illustration Generator"] && (
              <IllustrationGeneratorSetting
                activeItemData={activeItemData}
                isFirstStep={isFirstStep}
                selectedToDropdownItem={selectedToDropdownItem}
                selectedFromDropdownItem={selectedFromDropdownItem}
                setSelectedFromDropdownItem={setSelectedFromDropdownItem}
                setSelectedToDropdownItem={setSelectedToDropdownItem}
                canShow={appsVisibility["Illustration Generator"]}
                readOnly={false}
              />
            )}
            {appsVisibility["Image Restore"] && (
              <ImageRestoreSetting
                isFirstStep={isFirstStep}
                canShow={appsVisibility["Image Restore"]}
                readOnly={false}
              />
            )}
            {appsVisibility["Text Extractor"] && (
              <TextExtractionSetting
                isFirstStep={isFirstStep}
                canShow={appsVisibility["Text Extractor"]}
                readOnly={false}
              />
            )}
            {appsVisibility["Background Remover"] && (
              <BackgroundRemoverSetting
                isFirstStep={isFirstStep}
                canShow={appsVisibility["Background Remover"]}
                readOnly={false}
              />
            )}
            {appsVisibility["Text to Video"] && (
              <TextToVideoSetting
                currentStep={currentStep}
                videoSettings={currentStep?.videoSettings}
                readOnly={false}
                handleModelSettingChanges={handleModelSettingChanges}
                canShow={appsVisibility["Text to Video"]}
                isFirstStep={isFirstStep}
              />
            )}
            {appsVisibility["Image to Video"] && (
              <ImageToVideoSetting
                currentStep={currentStep}
                videoSettings={currentStep?.videoSettings}
                readOnly={false}
                handleUserInputImageChange={handleUserInputImageChange}
                handleUserInputTextChange={handleUserInputTextChange}
                outputTypeOfLastApp={outputTypeOfLastApp}
                handleModelSettingChanges={handleModelSettingChanges}
                canShow={appsVisibility["Image to Video"]}
                isFirstStep={isFirstStep}
              />
            )}
          </div>
          <div className="w-100 d-flex mt-3 align-items-center justify-content-end">
            <button
              className="CancelDeletePersonaBtn cancelCreation me-3"
              onClick={cancelNewStep}
            >
              Cancel
            </button>
            <button
              className={`saveStep-btn ${
                isSaveStepDisabled ? "disabled" : "active"
              }`}
              disabled={isSaveStepDisabled}
              onClick={addNewStep}
            >
              Save step
            </button>
          </div>
        </Modal.Body>
      )}
    </Modal>
  );
};

export default PopupForDisplayApp;
